var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_839_206)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#FFCACA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1628 20.2078H30.8532C30.4891 20.2818 30.1989 20.5025 29.9052 20.702C28.8546 21.4069 27.9917 22.3522 27.3899 23.4574C26.8735 24.4021 26.5575 25.4411 26.4612 26.5108C26.4177 26.9988 26.4213 27.4899 26.472 27.9773C26.3436 27.87 26.2729 27.7579 26.1907 27.6583C25.9427 27.348 25.7217 27.0175 25.5302 26.6703C25.2627 26.2033 24.8064 26.1288 24.4299 26.5073C23.1636 27.7801 22.3919 29.2922 22.1659 31.0732C21.9731 32.5359 22.2139 34.0225 22.8591 35.3526C23.5279 36.7557 24.5377 37.8632 25.8709 38.6834C26.7445 39.2199 27.7177 39.5785 28.7334 39.7381C28.9353 39.7709 29.1425 39.7495 29.3438 39.7923H29.6534C29.6833 39.7769 29.7165 39.7689 29.7502 39.7689C29.7838 39.7689 29.817 39.7769 29.8469 39.7923H30.3113C30.3344 39.7672 30.3654 39.774 30.3942 39.7725C30.4165 39.7726 30.4387 39.7726 30.4609 39.7725C30.4897 39.7739 30.5205 39.7672 30.5436 39.7922H30.7371C31.379 39.7446 32.0116 39.6121 32.6178 39.398C33.6798 39.0286 34.649 38.4378 35.4597 37.6657C36.5337 36.6529 37.2426 35.4315 37.6311 34.0229C37.7591 33.5423 37.841 33.0508 37.8758 32.5551C37.9904 31.1173 37.6847 29.7672 37.03 28.491C36.4265 27.315 35.5604 26.3636 34.4702 25.6003C32.7898 24.4238 31.8459 22.8141 31.6365 20.7869C31.606 20.4919 31.462 20.2879 31.1628 20.2078Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8472 39.7923C29.8349 39.779 29.82 39.7683 29.8033 39.7611C29.7867 39.7538 29.7686 39.75 29.7504 39.75C29.7322 39.75 29.7142 39.7538 29.6975 39.7611C29.6808 39.7683 29.6659 39.779 29.6537 39.7923H29.8472Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5435 39.7922C30.5329 39.7482 30.4997 39.7561 30.4683 39.76C30.4542 39.7662 30.4492 39.7731 30.4532 39.7805C30.4574 39.7883 30.4616 39.7922 30.4661 39.7922L30.5435 39.7922Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4661 39.7923C30.4663 39.7816 30.4671 39.7708 30.4683 39.7602L30.3913 39.7595C30.377 39.7657 30.3718 39.7726 30.3758 39.7803C30.38 39.7883 30.3842 39.7923 30.3887 39.7923H30.4661Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3889 39.7923C30.3892 39.7813 30.3901 39.7703 30.3916 39.7595C30.3765 39.7545 30.3601 39.7551 30.3454 39.7611C30.3307 39.7671 30.3187 39.7782 30.3115 39.7923H30.3889Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_839_206",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_206"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 38 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireCat);
export default __webpack_public_path__ + "static/media/Fire_cat.1a8937ad350e06492518fbead4b8def3.svg";
export { ForwardRef as ReactComponent };